export class WarningsComponent {
  constructor(parent) {
    this.parent = parent;
    this.$container = parent.$container;
    this.controller = parent.controller;
  }

  async activateSwatchGroup($swatchGroup) {
    const name = $swatchGroup.attr('data-name');

    // remove warnings when clear option is picked.
    if (name === '-clear-option-') {
      this.remove_warning();
    }
  }

  async applySwatch(applySwatch) {
    if (applySwatch && applySwatch.options) {
      let $warning_el = this.$container.parent().find(`#${this.parent.id} .warning`);
      if (applySwatch.options.warning_message) {
        this.set_warning(applySwatch.options.warning_message);
      } else {
        this.remove_warning();
      }
    }
  }

  set_warning(message) {
    const $warning_el = this.$container.parent().find(`#${this.parent.id} .warning`);
    $warning_el.html(message);
    $warning_el.removeClass("hide");
    this.controller.addWarnings(this.parent.id, message);
  }

  remove_warning() {
    const $warning_el = this.$container.parent().find(`#${this.parent.id} .warning`);
    $warning_el.html("");
    $warning_el.addClass("hide");
    this.controller.addWarnings(this.parent.id, null);
  }
}